@if (isLoading) {
	<div class="overlay-new"></div>
}

<!-- This overlay is for the file uploader -->
@if (loadingSubject | async) {
	<div class="overlay" style="z-index: 999999999; background-color: rgba(255, 255, 255, 0.8); position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; flex-direction: row; justify-content: center; align-items: center">
		<img src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">
		{{ 'insights.administration.reports.title' | translate }}
	</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input [value]="searchText" matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.reports.search' | translate" [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<button mat-button (click)="applyActiveOnlyFilter()" style="margin-right: 16px">
			<mat-icon svgIcon="{{ activeOnly ? 'acies_check' : 'acies_uncheck' }}" style="margin-right: 8px"></mat-icon>
			{{ 'insights.administration.reports.onlyactive' | translate }}
		</button>

		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<table class="table-responsive" mat-table recycleRows [dataSource]="dataSource" matSort [ngClass]="{ 'example-table-loading': isLoading }">
	<ng-container matColumnDef="select">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let row">
			@if (row.status === activeLabel) {
				<mat-icon mat-list-icon class="account-select-icon" svgIcon="{{ selected.includes(row) ? 'acies_check' : 'acies_uncheck' }}" style="padding-top: 5px" (click)="select(row)"></mat-icon>
			}
		</td>
	</ng-container>

	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.colname' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.name }}</td>
	</ng-container>

	<ng-container matColumnDef="type">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.coltype' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ 'insights.administration.reports.table.type' + element.type | translate }}
		</td>
	</ng-container>

	<ng-container matColumnDef="categoryName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.category' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ element.categoryName ? element.categoryName : element.categoryId }}
		</td>
	</ng-container>

	<ng-container matColumnDef="externalId">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.colreports' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.externalId }}</td>
	</ng-container>

	<ng-container matColumnDef="groupId">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.colgroups' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.groupId.split('-').shift() }}</td>
	</ng-container>

	<ng-container matColumnDef="url">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.colurl' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.url }}</td>
	</ng-container>

	<ng-container matColumnDef="createdDate">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.col_created' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ element.createdDate | aciesDateFormat: true }}
		</td>
	</ng-container>

	<ng-container matColumnDef="updatedDate">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.col_updated' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ element.updatedDate | aciesDateFormat: true }}
		</td>
	</ng-container>

	<ng-container matColumnDef="status">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.reports.table.colstatus' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ 'insights.administration.reports.table.status' + element.status | translate }}
		</td>
	</ng-container>

	<ng-container matColumnDef="menu">
		<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
		<td mat-cell *matCellDef="let row" style="text-align: end">
			@if (row.status === inactiveLabel || row.type === externalLabel) {
				<button mat-icon-button [matMenuTriggerFor]="menu" (click)="selectSingle(row)">
					<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_overflow_menu" style="padding-top: 5px; overflow: visible"></mat-icon>
				</button>
			}
			<mat-menu #menu="matMenu">
				@if (row.type === externalLabel) {
					<button mat-menu-item (click)="onEditExternalUrl(row)">
						<span>
							{{ 'insights.administration.reports.externalurl.edit' | translate }}
						</span>
					</button>
				}
				@if (row.status === inactiveLabel) {
					<button mat-menu-item (click)="onReactivateReport(row)">
						<span>
							{{ 'insights.administration.reports.reactivatebtn' | translate }}
						</span>
					</button>
				}
				@if (row.status === inactiveLabel) {
					<button mat-menu-item (click)="onPermanentlyDeleteReport(row)">
						<span>
							{{ 'insights.administration.reports.permanentlydeletebtn' | translate }}
						</span>
					</button>
				}
			</mat-menu>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="20" showFirstLastButtons [length]="resultsLength"></mat-paginator>
